import { TGeo, TRole, TStatus } from "./globals";
import { IWorkspace } from "./workspace.interface";

export interface IProspectUser {
  id: string;
  firstName?: string;
  lastName?: string;
  name?: {
    first: string;
    last: string;
  };
  email?: string;
  image?: string;
  status?: TStatus;
  phoneNumber?: string;
  position?: TRole;
  prospectId?: string;
  role?: string;
  Prospect?: {
    id: string;
    name: string;
    officialName: string;
    logo: string;
    shortName: string;
    workspace: IWorkspace;
  };
  permissions: {
    customerPortal: boolean;
    projectFinance: boolean;
    emailNotification: boolean;
  };
  createdAt: string;
}

export interface IProspect {
  id: string;
  email: string;
  createdAt: string;
  updatedAt: string;
  name?: string;
  shortName?: string;
  officialName?: string;
  abn?: string;
  logo?: string;
  address?: TGeo;
  phoneNumber?: string;
  workspaceId?: string;
  workspace: IWorkspace;
  prospectUsers?: IProspectUser[];
}

export enum ProspectUserPositions {
  "Operation Manager",
  "Project Manager",
  "Sr. Project Manager",
  "Project Director",
  "Construction Manager",
  "Pre Construction Manager",
  "Managing Director",
  "Director",
  "General Manager",
  "Project Co-ordinator",
  "Project Administer",
  "ACCOUNT",
}
